import {
  Avatar,
  Box,
  Card,
  CardContent,
  Divider,
  Typography,
  Grid2,
  CardActionArea,
} from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import { CardHeader } from "react-bootstrap";

const BillingDetailsCard = ({ companyBilling }) => {
  const display = (label, value) => (
    <Grid2 item>
      <Typography variant="body">
        {label}:{" "}
        {value || (
          <WarningAmberIcon fontSize="small" sx={{ color: "orange" }} />
        )}
      </Typography>
    </Grid2>
  );
  return (
    <Card sx={{ p: 2, mb: 2, boxShadow: 3 }}>
      <CardContent>
        <Grid2 container spacing={2} sx={{ justifyContent: "space-between" }}>
          {/* Columna izquierda - 50% */}
          <Grid2 item xs={12} sm={6} sx={{ width: "48%" }}>
            <Grid2 container direction="column" spacing={1}>
              {display("RUT", companyBilling.rut)}
              {display("Razón Social", companyBilling.razonSocial)}
              {display("Nombre de Fantasía", companyBilling.nombreFantasia)}
              {display("Dirección", companyBilling.direccion)}
              {display("Comuna", companyBilling.comuna)}
              {display("Ciudad", companyBilling.ciudad)}
              {display("Región", companyBilling.region)}
            </Grid2>
          </Grid2>

          {/* Columna derecha - 50% */}
          <Grid2 item xs={12} sm={6} sx={{ width: "48%" }}>
            <Grid2 container direction="column" spacing={1}>
              {display("Correo de Facturación", companyBilling.correo)}
              {display("Teléfono", companyBilling.telefono)}
              {display("Centro de Costo", companyBilling.centroCosto)}
              {display("Forma de Pago", companyBilling.formaPago)}
              {display("Días de Pago", companyBilling.diasPago)}
              {display("Contacto de Cobranza", companyBilling.contacto)}
              {display("Email de Contacto", companyBilling.contactoEmail)}
              {display("Teléfono de Contacto", companyBilling.contactoTel)}
            </Grid2>
          </Grid2>
        </Grid2>
      </CardContent>
    </Card>
  );
};

export default BillingDetailsCard;
